import { CoinType } from "@onmo/graphql/graphql";
import GemIcon from "../assets/rankGem/webp/gem_1x.webp";
import GemIcon2x from "../assets/rankGem/webp/icon2x/gem_2x.webp";
import GemIcon3x from "../assets/rankGem/webp/icon3x/gem_3x.webp";
import GZCoinIcon from "../assets/icon/gamezone_coin/gamezone_coin_1x.webp";
import GZCoinIcon2x from "../assets/icon/gamezone_coin/gamezone_coin_2x.webp";
import GZCoinIcon3x from "../assets/icon/gamezone_coin/gamezone_coin_3x.webp";
import VBIcon from "../assets/icon/vodabucks/vodabucks_1x.webp";
import VBIcon2x from "../assets/icon/vodabucks/vodabucks_2x.webp";
import VBIcon3x from "../assets/icon/vodabucks/vodabucks_3x.webp";

export interface CurrencyIcon {
  src: string;
  src2x: string;
  src3x: string;
}

export interface WalletConfig {
  primaryCurrency: {
    base: CoinType;
    spendable: CoinType;
  };
  secondaryCurrencies: CoinType[];
}

export const getWalletBalance = (
  coinWallets: { itemType: string; balance: number }[],
  coinType: CoinType,
): number => {
  if (!coinWallets) return 0;
  return coinWallets.find((w) => w.itemType === coinType)?.balance || 0;
};

export const DEFAULT_WALLET_CONFIG: WalletConfig = {
  primaryCurrency: {
    base: CoinType.Gems,
    spendable: CoinType.SpendableGems,
  },
  secondaryCurrencies: [],
};

export const CURRENCY_ICON_MAP: Record<string, CurrencyIcon> = {
  [CoinType.Gems]: {
    src: GemIcon,
    src2x: GemIcon2x,
    src3x: GemIcon3x,
  },
  [CoinType.SpendableGems]: {
    src: GemIcon,
    src2x: GemIcon2x,
    src3x: GemIcon3x,
  },
  [CoinType.GzTokens]: {
    src: GZCoinIcon,
    src2x: GZCoinIcon2x,
    src3x: GZCoinIcon3x,
  },
  [CoinType.SpendableGzTokens]: {
    src: GZCoinIcon,
    src2x: GZCoinIcon2x,
    src3x: GZCoinIcon3x,
  },
  [CoinType.Vodabucks]: {
    src: VBIcon,
    src2x: VBIcon2x,
    src3x: VBIcon3x,
  },
};

export const getCurrencyIcon = (coinType: string): CurrencyIcon => {
  return CURRENCY_ICON_MAP[coinType] || CURRENCY_ICON_MAP[CoinType.Gems];
};
